import Box from "@mui/material/Box";
import { colorPalette } from '../../colorPalette';
import React from 'react';
import { statusStyle } from './Status.style';
export const Status = ({ label, color, icon, dataQa = 'status-component' }) => {
    return (React.createElement(Box, { "data-qa": dataQa, sx: Object.assign(Object.assign({}, statusStyle), { backgroundColor: `${colorPalette[`${color}100`]}`, color: color === "yellow" ? `${colorPalette[`${color}900`]}` : `${colorPalette[`${color}800`]}`, '& svg': {
                color: `${colorPalette[`${color}700`]}`,
                marginLeft: '-4px',
                fontSize: '1.5rem'
            } }) },
        !!icon && icon,
        label));
};
